import { buildModelManager } from "../builder.js";
const DefaultQaChartFieldSelection = {
  __typename: true,
  id: true,
  chartId: true,
  contextWindow: true,
  createdAt: true,
  evidenceSpan: true,
  extractionMethod: true,
  fieldId: true,
  mappingResult: true,
  pageNumber: true,
  rawValue: true,
  section: true,
  sourceField: true,
  sourceLabel: true,
  updatedAt: true
};
const modelApiIdentifier = "qaChartField";
const pluralModelApiIdentifier = "qaChartFields";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaChartFieldSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaChartFieldSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaChartFieldSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaChartFieldSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaChartFieldSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaChartFieldSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaChartFieldSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "qaChartFieldGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QaChartFieldManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQaChartFieldSelection,
  operations
);
export {
  DefaultQaChartFieldSelection,
  QaChartFieldManager
};
//# sourceMappingURL=QaChartField.js.map
